<template>
  <div class="statistics">
    <div class="columns">
      <div class="column is-3" style="text-align:center;">
        <Datepicker />
      </div>
      <div class="column">
        <h1 class="title is-4" style="text-align:center;">{{month_path}}月{{day_path}}日のデータ</h1>
        <article class="message is-info">
          <div class="message-body">
            <p class="title is-5">書いた文字数 {{this.message_length}}文字</p>
            <p class="title is-5">執筆開始時間 {{this.startTime}}</p>
            <p class="title is-5">執筆時間 {{this.writing_info.length}}分</p>
            <p class="title is-5">感情スコア {{score}}</p>
            <p class="title is-5">振れ幅 {{magnitude}}</p>
          </div>
        </article>
        <BarChartWritingData />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '@/components/Datepicker.vue'
import firebase from '@firebase/app'
import BarChartWritingData from '@/components/barCharts/BarChartWritingData.vue'
export default {
  components: {
    Datepicker,
    BarChartWritingData,
  },
  data(){
    return{
      year_path: '',
      month_path:'',
      day_path: '',
      score: '',
      magnitude: '',
      writing_info: [],
      message_length: 0,
      startTime: '',
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    }
  },
  mounted(){
    const title = "日次データ｜エモーションダイアリー"
    const description = "日次データ画面"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  }, 
  created(){
    var [ , , year_path, month_path, day_path] = location.pathname.split('/')
    this.year_path = year_path
    this.month_path = month_path
    this.day_path = day_path

    firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).doc(String(day_path)).get().then((doc) => {
      var data = doc.data()
      this.message = data.message
      this.message_length = data.length
      this.writing_info = data.writing_info
      this.startTime = data.writing_info[0].time.toDate().toLocaleTimeString('ja', { hour: 'numeric', minute: 'numeric'})
      this.score = Math.round(data.score * 100)
      this.magnitude = Math.round(data.magnitude * 100) /100
    });
  },
}
</script>

<style scoped>
.statistics{
  padding:10px;
}
.barChart{
  width: 400px;
  height: 800px;
}
.pieChart{
  width: 400px;
  height: 400px;
}
</style>